import { SVGProps } from 'react';

function Clip(props: JSX.IntrinsicAttributes & SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={12}
      height={14}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.375 8.874V4.75a3.375 3.375 0 0 0-6.75 0v5.625a2.25 2.25 0 0 0 4.5 0V4.75a1.125 1.125 0 0 0-2.25 0v4.875"
        stroke="#232B43"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

Clip.defaultProps = {
  role: 'graphics-document',
};

export default Clip;
